// extracted by mini-css-extract-plugin
export var column = "bH_dc";
export var container = "bH_b";
export var icon = "bH_bq";
export var link = "bH_bx";
export var title = "bH_h";